module.exports = __webpack_public_path__ + "img/SES_191428809.03425be0.jpg";